var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test-question-filter-by-product-group"},[_c('i-tree',{attrs:{"data":_vm.data,"expand-node":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }